import { render, staticRenderFns } from "./job-seeker-register.vue?vue&type=template&id=30bc2741&scoped=true"
import script from "./job-seeker-register.vue?vue&type=script&lang=js"
export * from "./job-seeker-register.vue?vue&type=script&lang=js"
import style0 from "./job-seeker-register.vue?vue&type=style&index=0&id=30bc2741&prod&lang=scss"
import style1 from "./job-seeker-register.vue?vue&type=style&index=1&id=30bc2741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc2741",
  null
  
)

export default component.exports